/* eslint-disable import/no-named-as-default */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ShoppingCart from './ShoppingCart';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.

class App extends Component {
  render() {
    return (
      <div className="shopping-cart">
        <ShoppingCart/>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default App;
